import React, { useState, useEffect } from 'react';
import './signup.css';
import cbor from 'cbor-js';
import axios from 'axios';
import { showErrorToast } from '../../toast-utils';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';

const Signup = ({ token, socket, hashValue, publicKey, userid, user, url, payload, params, tenant }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState(null);
  const [duplicate, setDuplicate] = useState(false);
  const [registererror, setRegisterError] = useState(false);
  const [text, setText] = useState('');
  const [userError, setUserError] = useState(false);

  useEffect(() => {
    socket.on('signup_response', function (response) {
      if (response.username) {
        console.log(response.username)
        socket.disconnect();
      } else {
        console.log(response)
        setDuplicate(true);
        socket.disconnect();
      }
    })

    socket.on('intruder_response', function (response) {
      console.log('intruder-response');
      socket.disconnect();
    })

    return () => {
      console.log('Component unmounted');
      socket.disconnect();
    };

  }, []);

  function generateRandom() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    });
  }

  async function getEncryptedData(data) {

    var key = generateRandom(), iv = generateRandom();

    var keyEnc = CryptoJS.enc.Utf8.parse(key),
      keyEnciv = CryptoJS.enc.Utf8.parse(iv);
    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyEnc, { iv: keyEnciv, mode: CryptoJS.mode.CBC });

    let jsEncrypter = new JSEncrypt();
    jsEncrypter.setPublicKey(publicKey);

    return {
      key: jsEncrypter.encrypt(key),
      iv: jsEncrypter.encrypt(iv),
      data: encrypted.toString()
    };
  }

  async function generateSHA256Hash(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  let loginData;
  let fetchUrl = url;

  const handleLogin = async (e) => {
    e.preventDefault();
    if (user !== username) {
      setUserError(true)
      return;
    }

    // console.log(url)
    // console.log(payload)
    // console.log(params)

    // if (payload.includes('tenant_id')) {
    //   console.log('yes')
    //   const loginObj = {
    //     user_login_id: username,
    //     tenant_id: tenant,
    //     password: password,
    //     session_id: ''
    //   }
    //   loginData = await (getEncryptedData(loginObj));
    //   console.log(loginData)
    // } else if (params) {
    //   const param = `username=${username}&password=${password}`
    //   fetchUrl += '?' + param;
    // } else {
    //   loginData = {
    //     username: username,
    //     password: password
    //   }
    // }

    try {
      const loginObj = {
        user_login_id: username,
        tenant_id: tenant,
        password: password,
        session_id: ''
      }
      loginData = await (getEncryptedData(loginObj));
      const response = await fetch('https://uat-api.adapid.link/api/v4/desktop/signin/', {
        method: 'POST',
        body: JSON.stringify(loginData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const data = await response.json();
      console.log(data)

      const deviceDetails = {
        user_agent: navigator.userAgent,
        user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: window.navigator.language,
        user_screen_height: window.screen.height,
        user_screen_width: window.screen.width,
        webgl: hashValue,
        browser_languages: window.navigator.languages[0],
        maxtouch_points: navigator.maxTouchPoints,
        app_name: navigator.appName,
        vendor: navigator.vendor,
        product: navigator.product,
        product_sub: navigator.productSub,
      }

      const registerObj = {
        tenant_id: tenant,
        token: token,
        username: username,
        attestation: "none",
        rp_id: "authenticate-uat.adapid.link",
        rp_name: "https://authenticate-uat.adapid.link"
      }

      const registerEnc = await getEncryptedData(registerObj);
      try {
        const response = await fetch('https://uat-webauthn.adapid.link/api/v1/user/register/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...registerEnc
            }),
          });

        const result = await response.json();

        if (result.message === 'Failed to insert user registration data') {
          setError(true);
          setText(result.message)
        }
        const registerData = { "rp": { "name": "https://authenticate-uat.adapid.link", "id": "authenticate-uat.adapid.link" }, "user": { "id": result.user.id, "name": result.user.name, "displayName": result.user.displayName }, "challenge": result.challenge, "pubKeyCredParams": [{ "type": "public-key", "alg": -7 }, { "type": "public-key", "alg": -257 }], "timeout": 60000, "authenticatorSelection": { "authenticatorAttachment": "platform", "requireResidentKey": false, "userVerification": "preferred" }, "attestation": "none" }
        const registerHash = await generateSHA256Hash(JSON.stringify(registerData));
        if (((result.id).substring(4, (result.id.length) - 4)) === registerHash) {

          const challenge = Uint8Array.from(result.challenge, c => c.charCodeAt(0))
          const id = Uint8Array.from(result.user.id, c => c.charCodeAt(0))
          result.challenge = challenge
          result.user.id = id;

          const credential = await navigator.credentials.create({
            publicKey: result,
          });

          const attestation = btoa(String.fromCharCode.apply(null, new Uint8Array(credential.response.attestationObject)));
          const clientData = btoa(String.fromCharCode.apply(null, new Uint8Array(credential.response.clientDataJSON)));
          const decodedAttestationObject = cbor.decode(credential.response.attestationObject);

          const { authData } = decodedAttestationObject;
          const authenData = btoa(String.fromCharCode.apply(null, new Uint8Array(authData)));
          const dataView = new DataView(new ArrayBuffer(2));
          const idLenBytes = authData.slice(53, 55);
          idLenBytes.forEach(
            (value, index) => dataView.setUint8(
              index, value));
          const credentialIdLength = dataView.getUint16();
          const publicKeyBytes = authData.slice(55 + credentialIdLength);
          const publickey = btoa(String.fromCharCode.apply(null, new Uint8Array(publicKeyBytes)));

          const verifyObj = {
            token: token,
            'tenant_id': tenant,
            "rp_id": 'authenticate-uat.adapid.link',
            "username": username,
            "response": {
              "id": credential.id,
              "rawId": credential.id,
              "response": {
                "attestationObject": attestation,
                "clientDataJSON": clientData,
                "transports": [
                  "internal"
                ],
                "publicKeyAlgorithm": -257,
                "publicKey": publickey,
                "authenticatorData": authenData
              },
              "type": "public-key",
              "clientExtensionResults": {
                "credProps": {}
              },
              "authenticatorAttachment": "platform"
            }
          }

          const verifyEnc = await getEncryptedData(verifyObj);

          try {
            const responseRegister = await fetch('https://uat-webauthn.adapid.link/api/v1/user/verify/',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  ...verifyEnc
                }),
              });
            const register = await responseRegister.json();

            const verifyData = { "Verified": true, "status_code": "200" }
            const verifyHash = await generateSHA256Hash(JSON.stringify(verifyData));

            if (((register.id).substring(4, (register.id.length) - 4)) === verifyHash) {
              if (register.verified) {
                socket.emit('signup', {
                  'username': username, 'password': password, 'devicedetails': deviceDetails, 'token': token, 'tenant_id': tenant,
                });
                setIsLoggedIn(true);
                setError(false);
              } else if (register.error) {
                setText(register.error)
                setError(true)
              } else if (register.Error) {
                showErrorToast('Intruder')
                socket.emit('intruder', { 'error': 'Intruder', 'token': token })
                setText('Username registered with a different device, try with a different username')
                setError(true)
              }
            } else {
              showErrorToast('Signup failed');
            }
          } catch (error) {
            console.log(error)
            setError(true);
          }
        } else {
          showErrorToast('Signup failed');
        }
      } catch (error) {
        setText('Registration failed')
        setError(true)
      }
    } catch (error) {
      console.error('Error making API call:', error);
    }

  };

  return (
    <div className="container">
      <div className="login-container">
        {!isLoggedIn ? (
          <div className="form-container">
            <h3>Login</h3>
            <p>Register for passwordless login : Enter your credentials</p>
            <form action="" onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="Username"
                name="name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required autoComplete="off" autoCapitalize="none"
              />
              <input
                type="password"
                placeholder="Password"
                name="pass"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required autoComplete="off"
              />
              <button className="opacity" type="submit">SUBMIT</button>
              {error && <div style={{ marginTop: '5px', color: 'red' }}>{text}</div>}
              {registererror && <div style={{ marginTop: '5px', color: 'red' }}>Registration failed<br /> Scan again to register</div>}
              {userError && <div style={{ marginTop: '5px', color: 'red' }}>Invalid username</div>}
            </form>
          </div>
        ) : (
          <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
            {duplicate ? (
              <div style={{ color: 'red' }}>Error occurred</div>
            ) : (
              <div style={{ color: 'green' }}>User profile successfully created</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;